'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgFileGuideFill = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M13 3.89v17.53l9-1.59V2.31l-9 1.58Zm6.5 10.85-4 .71v-2.03l4-.71v2.03Zm0-4.06-4 .71V9.35l4-.71v2.04ZM2 19.84l9 1.59V3.89L2 2.31v17.53Z" })
);

module.exports = SvgFileGuideFill;
//# sourceMappingURL=FileGuideFill.cjs.js.map
